"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _TableContext = require("./TableContext");

var css = _interopRequireWildcard(require("./Table.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Table = /*#__PURE__*/React.forwardRef(({
  borderCollapse = 'collapse',
  borderSpacing = 0,
  layout = 'auto',
  padding = 'small',
  stickyHeader = false,
  variant = 'primary',
  ...otherProps
}, ref) => {
  const table = React.useMemo(() => ({
    padding,
    stickyHeader,
    variant
  }), [padding, stickyHeader, variant]);
  return (0, _pragma.createFelaElement)(_TableContext.TableContext.Provider, {
    value: table
  }, (0, _pragma.createFelaElement)("table", _extends({
    css: css.table,
    cssProps: {
      borderCollapse,
      borderSpacing,
      layout,
      variant
    },
    ref: ref
  }, otherProps)));
});
Table.displayName = 'Table';
var _default = Table;
exports.default = _default;
//# sourceMappingURL=Table.js.map